/**
 * Created by Alex Aguilar on 9/7/2016.
 */
(function(){
    'use strict';

    var headerPage = {
        templateUrl: 'app/components/header/header.html',
        controller: headerController,
        controllerAs: 'vm'
    }

    angular
        .module('completeAir')
        .component('headerPage', headerPage);

    headerPage.$inject = ['$state', 'Auth', 'linkService','$rootScope', 'Principal']

    function headerController($state, Auth, linkService, $rootScope, Principal){
        var vm = this;
        vm.isLoggedIn = Auth.isLoggedIn;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.logout = function(){
            Auth.logout();
            $rootScope.$broadcast('navbar', []);
            $state.go('home');
        }

        //Auth.authorize();

        vm.refresh = function(){
            vm.isLogin = Principal.isAuthenticated;
            if(vm.isLogin){
                vm.loginNames = $rootScope.loginNames;
                vm.loginInitials = $rootScope.loginInitials;
                return true;
            }
            return false;
        }
    }
})();
